import React, { useEffect, useMemo, useState } from "react";
import { Source, Layer } from "react-map-gl";

import _ from "lodash";

import {
  clusterLayer,
  fieldsBorderLayerAlt,
  fieldsHighlightLayer,
  fieldsLayer,
  fieldsSelectedBorderLayerAlt,
  unclusteredLayer,
} from "./Map/styles/fields";

import {
  DataSourceLayerMeta,
  DataSourceRasterLayer,
  Field,
  LayerVisibility,
} from "./../types/types";

import {
  createCentroidFeatureFromField,
  createCentroidFeatureFromGeom,
  __createCentroidFeatureFromGeom,
  createFeatureCollection,
  createFeatureFromField,
} from "./../utils/mapUtils";

import { useLayerStoreSoilsView } from '../features/fields/providers/LayerProviderSoilsView' 
//providers/LayerProvider';

import { useRasterDataSources } from "../hooks/useRasterDataSources";
import { NAIP_DATA_SOURCE, ESRI_DATA_SOURCE } from "../constants";

const RASTER_DATA_SOURCES: DataSourceLayerMeta[] = [{
    id: NAIP_DATA_SOURCE,
    type: "base",
    name: "Historical Imagery",
    order: 4,
    visible: true,
    minZoom: 10,
    maxZoom: 24,
  },{
    id: ESRI_DATA_SOURCE,
    type: "base",
    name: "Mapbox Imagery",
    order: 4,
    visible: true,
    minZoom: 0,
    maxZoom: 10,
  },
];

interface Props {
  fields: Field[] | undefined;
  selectedFieldId: number | null;
  hoverFieldId: number | null;
  dateString: string | null;
}

const BaseMapLayers = ({ fields, selectedFieldId, hoverFieldId, dateString }: Props) => {
  const [showHighlightLayer] = useState<boolean>(true);
  const [fieldsDataSource, setFieldsDataSource] = useState(null);
  const [centroidDataSource, setCentroidDataSource] = useState(null);

  const { rasterLayers, clearLayers } = useLayerStoreSoilsView();
  //const [rasterDataSources, setRasterDataSources] = useState<DataSourceRasterLayer[]>([]);
  //const [overlayVisibility, setOverlayVisible] = useState<LayerVisibility[]>([]);

  //const { dataSources, loading: dataSourcesLoading } = useRasterDataSources(RASTER_DATA_SOURCES);

  const selectedId = selectedFieldId || "";
  const hoverId = hoverFieldId || "";

  const selectedFilter = useMemo(() => ["in", "id", selectedId], [selectedId]);
  const hoverfilter = useMemo(() => ["in", "id", hoverId], [hoverId]);

  useEffect(() => {
    if (fields) {
      const polygonFeatures = fields.map((f: Field) =>
        createFeatureFromField(f)
      );
      //console.log("C072225 dateString", dateString);
      const pointFeatures = fields.map((f: Field) => {
        let centField = createCentroidFeatureFromField(f, dateString)
        //let centGeom = createCentroidFeatureFromGeom(f.geom, dateString)
        //let cent__Geom = __createCentroidFeatureFromGeom(f.geom, dateString)
        //console.log("072925 cent__Geom", cent__Geom);
        //console.log("072925 centField", centField);
        //console.log("072925 centGeom", centGeom);
        //console.log("072925 f", f);
        return centField;
        //return centGeom;
        //return cent__Geom;
      });
      //console.log("071825 pointFeatures", pointFeatures);
      const polygonFeatureCollection = createFeatureCollection(polygonFeatures);
      const pointFeatureCollection = createFeatureCollection(pointFeatures);
      //console.log("062025 polygonFeatureCollection", polygonFeatureCollection);
      console.log("C072225 pointFeatureCollection", pointFeatureCollection);
      setFieldsDataSource(polygonFeatureCollection);
      setCentroidDataSource(pointFeatureCollection);
    }
  }, [fields, dateString]);

  /*useEffect(() => {
    if (!dataSourcesLoading && dataSources) {
      const layers: LayerVisibility[] = dataSources.map(
        (d: DataSourceRasterLayer) => {
          return {
            layer_id: d.id,
            layer_name: d.name,
            is_visible: d.is_visible,
            order: d.order,
          };
        }
      );

      if (overlayVisibility.length === 0) {
        setOverlayVisible(layers);
      }

      setRasterDataSources(dataSources);
    }
  }, [dataSources, dataSourcesLoading]);*/

  return (
    <>
      {["baselayer", "fieldlayer", "vectorbaselayer", "vectorlayer"].map(
        (name) => {
          return (
            <Layer
              key={name}
              id={"GROUP_" + name}
              type="background"
              layout={{ visibility: "none" }}
              paint={{}}
            />
          );
        }
      )}

      {/*rasterDataSources
        ? _.orderBy(rasterDataSources, ["order"], ["desc"]).map(
            (s: DataSourceRasterLayer) => (
              <Source
                key={s.uuid}
                id={s.uuid}
                type="raster"
                tileSize={256}
                tiles={s.tiles}
              >
                <Layer
                  key={s.uuid}
                  beforeId="GROUP_baselayer"
                  id={s.uuid}
                  type="raster"
                  source={s.uuid}
                  maxzoom={s.max_zoom}
                  minzoom={s.min_zoom}
                  layout={{
                    visibility: overlayVisibility.find((item) => {
                      return item.layer_id === s.id;
                    })?.is_visible
                      ? "visible"
                      : "none",
                  }}
                />
              </Source>
            )
          )
        : null*/}
      {rasterLayers ? _.orderBy(rasterLayers, ['order'], ['desc']).map((s: DataSourceRasterLayer) => (
              <Source key={s.id} id={s.id} type='raster' tileSize={256} scheme="tms" tiles={s.tiles}>
                  <Layer
                      key={s.id}
                      beforeId="GROUP_fieldlayer"
                      id={s.id}
                      type='raster'
                      source={s.id}
                      maxzoom={s.max_zoom}
                      minzoom={s.min_zoom}
                      layout={{ visibility: 'visible' }}
                  />
              </Source>)
      ) : null}
      <Source type="geojson" data={fieldsDataSource}>
        <Layer
          minzoom={10}
          {...fieldsLayer}
          beforeId="GROUP_vectorlayer"
        />
        <Layer
          minzoom={10}
          {...fieldsBorderLayerAlt}
          beforeId="GROUP_vectorlayer"
        />
        <Layer
          filter={selectedFilter}
          minzoom={10}
          {...fieldsSelectedBorderLayerAlt}
          beforeId="GROUP_vectorlayer"
        />
        {showHighlightLayer && (
          <Layer
            filter={hoverfilter}
            minzoom={10}
            {...fieldsHighlightLayer}
            beforeId="GROUP_vectorlayer"
          />
        )}
        {/*<Layer
          id="fields-labels"
          type="symbol"
          minzoom={10}
          layout={{
            "text-field": ["get", "name"],
            "symbol-placement": "point",
            "text-allow-overlap": false,
            "text-ignore-placement": false,
            "text-size": 12,
            "text-anchor": "center",
            "text-offset": [0, 0]
          }}
          paint={{
            "text-color": "#000",
            "text-halo-color": "#b0ede0",
            "text-halo-width": 1.5
          }}
          beforeId="GROUP_vectorlayer"
        />*/}

      </Source>
      <Source type="geojson" id="field-centroids" data={centroidDataSource}>
        <Layer
          id="field-labels"
          type="symbol"
          minzoom={12}
          beforeId="GROUP_vectorlayer" // or no beforeId so it’s on top
            layout={{
              "text-field": [
              "format",
              ["get", "name"], { "font-scale": 1.1 },
              "\n", {},
              [
                "case",
                [">", ["get", "pct_cloud_value"], 5],
                "CLOUDY",
                ""
              ], { "font-scale": 1.1 }
              ],
            //"text-field": ["get", "name"],
            "text-font": ["Open Sans Regular","Arial Unicode MS Regular"],
            "text-size": 15,
            "text-anchor": "center",
            "text-offset": [0, 0],
            // only label true points; if you still cluster, filter out cluster‐points:
            "symbol-placement": "point"
          }}
          paint={{
            "text-color": "#000",
            "text-halo-color": '#fff', //"#b0ede0",
            "text-halo-width": 1,
            "text-halo-blur": 0.5
          }}
        />
      </Source>

      {/*<Source type="geojson" data={fieldsDataSource}>
        <Layer beforeId="GROUP_vectorlayer" {...fieldsLayer} minzoom={10} />
        <Layer
          beforeId="GROUP_vectorlayer"
          {...fieldsBorderLayerAlt}
          minzoom={10}
        />
        <Layer
          beforeId="GROUP_vectorlayer"
          {...fieldsSelectedBorderLayerAlt}
          filter={selectedFilter}
          minzoom={10}
        />
        {showHighlightLayer && (
          <Layer
            beforeId="GROUP_vectorlayer"
            {...fieldsHighlightLayer}
            filter={hoverfilter}
            minzoom={10}
          />
        )}
      {/*<Source type="geojson" data={fieldsDataSource}>
        <Layer beforeId="GROUP_vectorlayer" {...fieldsLayer} minzoom={10} />
        <Layer
          beforeId="GROUP_vectorlayer"
          {...fieldsBorderLayerAlt}
          minzoom={10}
        />
        <Layer
          beforeId="GROUP_vectorlayer"
          {...fieldsSelectedBorderLayerAlt}
          filter={selectedFilter}
          minzoom={10}
        />
        {showHighlightLayer && (
          <Layer
            beforeId="GROUP_vectorlayer"
            {...fieldsHighlightLayer}
            filter={hoverfilter}
            minzoom={10}
          />
        )}
      </Source>*/}

      <Source
        type="geojson"
        data={centroidDataSource}
        cluster={true}
        clusterMaxZoom={8}
        clusterRadius={40}
      >
        <Layer beforeId="GROUP_vectorlayer" {...clusterLayer} maxzoom={10} />
        <Layer
          beforeId="GROUP_vectorlayer"
          {...unclusteredLayer}
          maxzoom={10}
        />
      </Source>
    </>
  );
};

export default BaseMapLayers;
